function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { buildComponentName } from '../utils';
import Icon from '../icon';
var colorReg = /^(pink|red|yellow|orange|cyan|green|blue|purple|geekblue|magenta|volcano|gold|lime)$/;
var __vue_script__ = {
  name: buildComponentName('Box'),
  components: {
    Icon: Icon
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ux-box'
    },
    bordered: {
      type: Boolean,
      default: false
    },
    flex: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    bodyClass: {
      type: String,
      default: ''
    },
    bodyStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      showHeader: false,
      showIcon: false,
      showTitle: false,
      showActions: false
    };
  },
  computed: {
    clazz: function clazz() {
      var _ref;

      var prefixCls = this.prefixCls,
          flex = this.flex,
          bordered = this.bordered,
          color = this.color;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-flex"), flex), _defineProperty(_ref, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_ref, "".concat(prefixCls, "-solid"), color), _defineProperty(_ref, "".concat(prefixCls, "-").concat(color), colorReg.test(color)), _ref;
    },
    headerStyle: function headerStyle() {
      var styleObject = {};
      var color = this.color;

      if (!colorReg.test(color)) {
        styleObject.background = color;
      }

      return styleObject;
    },
    bodyClazz: function bodyClazz() {
      var bodyClass = this.bodyClass,
          prefixCls = this.prefixCls;
      return ["".concat(prefixCls, "-body"), bodyClass];
    }
  },
  mounted: function mounted() {
    var _this$$slots = this.$slots,
        icon = _this$$slots.icon,
        title = _this$$slots.title,
        actions = _this$$slots.actions;
    this.showIcon = icon !== undefined || this.icon;
    this.showTitle = title !== undefined || this.title;
    this.showActions = actions !== undefined;
    this.showHeader = this.showIcon || this.showActions || this.showTitle;
  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.clazz
  }, [_vm.showHeader ? _c('div', {
    class: [_vm.prefixCls + '-header'],
    style: _vm.headerStyle
  }, [_vm.showTitle ? _c('h3', {
    class: [_vm.prefixCls + '-title']
  }, [_vm._t("icon", [_vm.showIcon ? _c('icon', {
    class: _vm.prefixCls + '-icon',
    attrs: {
      "type": _vm.icon
    }
  }) : _vm._e()]), _vm._t("title", [_vm._v(_vm._s(_vm.title) + " ")])], 2) : _vm._e(), _vm.showActions ? _c('div', {
    class: [_vm.prefixCls + '-actions']
  }, [_vm._t("actions")], 2) : _vm._e()]) : _vm._e(), _c('div', {
    class: _vm.bodyClazz,
    style: _vm.bodyStyle
  }, [_vm._t("default")], 2)]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "box.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  if (false) {
    var hook;

    if (false) {
      // In SSR.
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      component._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function (context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook !== undefined) {
      if (component.functional) {
        // register for functional component in vue file
        var originalRender = component.render;

        component.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = component.beforeCreate;
        component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }
  }

  return component;
}
/* style inject */

/* style inject SSR */

/* style inject shadow dom */


var __vue_component__ = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;